module.exports = __webpack_public_path__ + "img/icon-home-active.c21d7d80.png";